import { TransactionLineItem } from '../../../api/transactionLineItem/TransactionLineItem';

export interface OpenGameSessionSummary {
  lineItemId: number;
  enablementId?: number | null;
  gameId?: number | null;
  instanceId?: number | null;
}

export interface GameInProgressErrorBody {
  code: 'GameInProgress';
  message: string;
  openSessions: OpenGameSessionSummary[];
}

// Detects the 412 PreconditionFailed payload returned by CapturePreAuth when
// the transaction still has unended game sessions.
export const isGameInProgressError = (err: unknown): err is { status: 412; data: GameInProgressErrorBody } => {
  if (typeof err !== 'object' || err === null) return false;
  const e = err as { status?: unknown; data?: unknown };
  if (e.status !== 412) return false;
  const data = e.data as { code?: unknown } | undefined;
  return !!data && data.code === 'GameInProgress';
};

const isOpenGameLine = (li: TransactionLineItem) => li.gameEnablementId != null && !li.gameEnded && li.voidReasonId == null;

// Walk parent + child line items because games attached to a package live as children.
export const flattenLineItems = (lineItems: TransactionLineItem[]): TransactionLineItem[] => {
  const out: TransactionLineItem[] = [];
  for (const li of lineItems) {
    out.push(li);
    if (li.childTransactionLineItems?.length) out.push(...flattenLineItems(li.childTransactionLineItems));
  }
  return out;
};

export const findOpenGameLineItem = (lineItems: TransactionLineItem[]): TransactionLineItem | undefined =>
  flattenLineItems(lineItems).find(isOpenGameLine);

export const hasOpenGameLineItem = (lineItems: TransactionLineItem[]): boolean => flattenLineItems(lineItems).some(isOpenGameLine);

// True if this line item, or any of its descendants, has an unended game booking.
export const hasOpenGameInLineItemTree = (lineItem: TransactionLineItem): boolean => flattenLineItems([lineItem]).some(isOpenGameLine);
